import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgVerifiedBadge: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.074 17.786l-1.29-2.18-2.448-.534a.84.84 0 01-.534-.345.826.826 0 01-.156-.612l.245-2.514L.222 9.688A.831.831 0 010 9.109c0-.222.074-.415.222-.578l1.67-1.914-.246-2.514a.826.826 0 01.156-.612.84.84 0 01.534-.344l2.447-.534 1.29-2.18a.875.875 0 01.49-.39.863.863 0 01.623.033l2.314.98 2.314-.98a.863.863 0 01.623-.033c.207.067.37.196.49.39l1.29 2.18 2.447.534c.222.044.4.159.534.344.133.186.185.39.156.612l-.245 2.514 1.668 1.914a.832.832 0 01.223.578.832.832 0 01-.223.579L17.11 11.6l.245 2.514a.826.826 0 01-.156.612.84.84 0 01-.534.345l-2.447.534-1.29 2.18a.875.875 0 01-.49.39.863.863 0 01-.623-.034l-2.314-.98-2.314.98a.863.863 0 01-.623.033.875.875 0 01-.49-.39z"
        fill="currentColor"
      />
      <path
        d="M8.566 9.732l-1.29-1.268a.83.83 0 00-.613-.245.866.866 0 00-.634.267.844.844 0 00-.244.623c0 .252.081.46.244.623l1.914 1.913a.854.854 0 00.623.267.854.854 0 00.623-.267l3.782-3.782a.815.815 0 00.256-.623.907.907 0 00-.89-.901.828.828 0 00-.634.256L8.566 9.732z"
        fill="#fff"
      />
    </Icon>
  )
}
export default SvgVerifiedBadge
